import * as React from "react";
import { Combobox, Field } from "@/components/ui";
import { Category as LegacyCategory } from "@/interfaces";
import { Category, CategoryServices } from "@/services/bedrock";
import { usePaginatedCombobox, useSocialCoachSession } from "@/utils";

function fetchCategories(search: string | undefined, page: number) {
  return CategoryServices.getCategories({
    type: "LIBRARY",
    excludeUnusedCategories: false,
    search: search?.trim() || undefined,
    page,
    perPage: 100,
  });
}

interface Props {
  values: {
    categories: LegacyCategory[];
  };
  disabled: boolean;
  handleSetFieldValue?: (field: string, value: any) => void;
}

export function PromptCategories({ values: { categories }, disabled, handleSetFieldValue }: Props) {
  const { coachId } = useSocialCoachSession();
  const [catList, setCatList] = React.useState<Category[]>(
    categories.map(
      (c: LegacyCategory) =>
        ({
          id: c.categoryId,
          name: c.name,
          coachId: c.coachId,
          type: c.type,
        } as Category)
    )
  );

  const categoriesCombobox = usePaginatedCombobox<Category>(fetchCategories, true, catList, (query: string) => ({
    id: -new Date().getTime(),
    coachId: coachId!,
    type: "LIBRARY",
    name: query,
  }));

  React.useEffect(() => {
    handleSetFieldValue!(
      "categories",
      catList.map(
        c =>
          ({
            categoryId: c.id,
            name: c.name,
            coachId: c.coachId,
            type: c.type,
          } as LegacyCategory)
      )
    );
  }, [catList]);

  return (
    <Field>
      <Field.Label>Categories</Field.Label>
      <Combobox
        {...categoriesCombobox}
        disabled={disabled}
        onValueChange={(val, _eventDetails) => {
          setCatList(val ?? []);
          categoriesCombobox.onValueChange(val, _eventDetails);
        }}
        itemToStringLabel={item => item.name}
        placeholder="Select categories..."
        showClear
        className="w-full bg-white"
      />
    </Field>
  );
}
